import React, { useMemo } from 'react';
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from 'react-table';
import { money } from '../../../utils';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { Col, Container, Row, Spinner, Table } from 'react-bootstrap';
import { TablePagination } from '../../../components';
import './styles.scoped.css';

function getSortedIcon(isSorted, isSortedDesc) {
  let iconProp = <FaSort />;
  if (isSorted) {
    iconProp = isSortedDesc ? <FaSortDown /> : <FaSortUp />;
  }
  return iconProp;
}

const columnClassName = 'align-middle text-nowrap';
export const saClientRankingAMCColumns = [
  {
    Header: 'Branch',
    accessor: 'Branch',
    className: columnClassName,
  },
  {
    Header: 'LOB',
    accessor: 'LOB',
    className: columnClassName,
  },
  {
    Header: 'AMC',
    accessor: 'AMC',
    className: columnClassName,
  },
  {
    Header: 'T Invoice Company Name',
    accessor: 'T_INVOICE_COMPANY_NAME',
    className: columnClassName,
  },
  {
    Header: 'Customer BillTo Number',
    accessor: 'Customer_BillToNumber',
    className: columnClassName,
  },
  {
    Header: 'Bill Amount',
    accessor: 'Bill_Amount',
    className: columnClassName,
    Cell: ({ value }) => money.format(value),
  },
  {
    Header: 'Grand Total',
    accessor: 'Grand_Total',
    className: columnClassName,
    Cell: ({ value }) => money.format(value),
  },
  {
    Header: 'Percent of Grand',
    accessor: 'PercentofGrand',
    className: columnClassName,
  },
  {
    Header: 'Start Date',
    accessor: 'Start_Date',
    className: columnClassName,
  },
  {
    Header: 'End Date',
    accessor: 'End_Date',
    className: columnClassName,
  },
];

const SAClientRankingAMCTable = ({ data, loading, summaryOrDetail }) => {
  const memoData = useMemo(() => data, [data]);

  const tableInstance = useTable(
    {
      columns: saClientRankingAMCColumns,
      data: memoData,
      initialState: {
        pageSize: 200,
        sortBy: [
          {
            id: 'CreatedAt',
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
  } = tableInstance;

  const tableHeaders = headerGroups.map(headerGroup => {
    const headers = headerGroup.headers.map(column => (
      <th {...column.getHeaderProps(column.getSortByToggleProps())}>
        {column.render('Header')}
        <span>
          {column.canSort
            ? getSortedIcon(column.isSorted, column.isSortedDesc)
            : null}
        </span>
      </th>
    ));
    return <tr {...headerGroup.getHeaderGroupProps()}>{headers}</tr>;
  });

  const tableRows = page.map(row => {
    prepareRow(row);
    const cells = row.cells.map(cell => (
      <td
        {...cell.getCellProps({
          className: cell.column.className,
          style: cell.column.style,
        })}
      >
        {cell.render('Cell')}
      </td>
    ));

    return <tr {...row.getRowProps()}>{cells}</tr>;
  });

  return (
    <Container fluid>
      <Row className="align-items-center">
        <Col className="d-flex justify-content-center justify-content-md-end">
          <TablePagination tableInstance={tableInstance} />
        </Col>
      </Row>
      <Row>
        <Col className="border border-light rounded shadow-sm">
          <Table hover responsive borderless {...getTableProps()}>
            <thead className="text-nowrap">{tableHeaders}</thead>
            <tbody {...getTableBodyProps()}>{tableRows}</tbody>
          </Table>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {loading && <Spinner animation="border" />}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SAClientRankingAMCTable;
